module.exports = __webpack_public_path__ + "holdingsAsset.52baf5ace4bd1ab46b212bd9292c9505.png";